import $ from 'jquery';

export function initialize(context) {
    context = context || document;
    $('.toggle', context).hide().prev().after('<p><a class="open-link arrows" href="javascript:;">Lees meer<\/a><\/p>');

    $('.open-link', context).parent().next().each(function () {
        $(this).append('<a class="close-link" href="javascript:;">Sluiten</a>');
    });

    $('.close-link', context).on('click', function (e) {
        e.preventDefault();
        $(this).parent().slideToggle('slow').prev().slideToggle('slow');
        $('html,body').animate({scrollTop: $(this).parent().parent().offset().top}, 'slow');
    });

    $('.open-link', context).on('click', function (e) {
        e.preventDefault();
        $(this).parent().slideToggle('slow').next().slideToggle('slow');
    });
}

export default { initialize };